import React from 'react';
import CustomSelect from 'components/Inputs/Select/Select';
import MultiSelectWithSearchDynamic from '../../Inputs/MultiSelect/MultiSelectWithSearchDynamic';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import IconRadioChecked from '../../../static/icons/svgRadioChecked';
import IconRadio from '../../../static/icons/svgRadio';
import FormHelperText from '@mui/material/FormHelperText';
import classNames from 'classnames';
const styles = require('../styles.pcss');

interface ScopeSectionProps {
  radioButtonState: string;
  errorOrganizaition: string;
  errorAgency: string;
  errorUser: string;
  errorConfidence: string;
  confidence: string;
  onChangeRadioButton: (e: any, value: string) => void;
  onChangeConfidence: (e: any) => void;
  selectedOrgs: any;
  selectedAgencies: any;
  selectedUsers: any;
  companies: any;
  agencies: any;
  users: any;
  isLoadingCompanies: boolean;
  isLoadingAgencies: boolean;
  isLoadingUsers: boolean;
  selectedOrgChange: (value: any) => void;
  selectedAgenciesChange: (value: any) => void;
  selectedUsersChange: (value: any) => void;
  getCompanies: (value: string) => void;
  getAgencies: (value: string) => void;
  getUsers: (value: string) => void;
  isLoadingFeatures: boolean;
}

const ScopeSection: React.FC<ScopeSectionProps> = ({
  radioButtonState,
  errorOrganizaition,
  errorAgency,
  errorUser,
  errorConfidence,
  confidence,
  onChangeRadioButton,
  onChangeConfidence,
  selectedOrgs,
  selectedAgencies,
  selectedUsers,
  companies,
  agencies,
  users,
  isLoadingCompanies,
  isLoadingAgencies,
  isLoadingUsers,
  selectedOrgChange,
  selectedAgenciesChange,
  selectedUsersChange,
  getCompanies,
  getAgencies,
  getUsers,
  isLoadingFeatures,
}) => (
  <>
    <div className={classNames(styles.informationTitle, styles.addMarginTop)}>
      <h2>Scope</h2>
    </div>
    <div className={styles.row}>
      <div className={styles.inputWrapper}>
        <CustomSelect
          margin={'normal'}
          variant={'outlined'}
          className={styles.selectWrapper}
          error={errorConfidence}
          htmlFor={'input-confidence'}
          label={'Confidence'}
          id={'input-Confidence'}
          value={confidence}
          onChange={onChangeConfidence}
          renderError={errorConfidence && <FormHelperText error>{errorConfidence}</FormHelperText>}
          fullWidth={true}
          inputName={'confidence'}
          MenuProps={{
            style: { marginTop: 4, boxShadow: 'none' },
            anchorOrigin: {
              vertical: 'bottom',
              horizontal: 'left',
            },
            transformOrigin: {
              vertical: 'top',
              horizontal: 'left',
            },
          }}
          menuItems={[
            { key: 'production', value: 'production', label: 'Production' },
            { key: 'staging', value: 'staging', label: 'Staging' },
            { key: 'preview', value: 'preview', label: 'Preview' },
            { key: 'development', value: 'development', label: 'Development' },
            { key: 'test', value: 'test', label: 'Test' },
          ]}
        />
      </div>
    </div>
    <div className={styles.radiogroupFeature}>
      <RadioGroup
        aria-label=""
        name="organ"
        className={styles.radioGroupUpdatePopup}
        value={radioButtonState}
        onChange={onChangeRadioButton}
        id="radio-group-specific"
      >
        <FormControlLabel
          value={'all'}
          control={<Radio icon={<IconRadio width={16} height={16} />} checkedIcon={<IconRadioChecked width={16} height={16} />} className={styles.checkboxReview} />}
          label={<span className={styles.radioGroupLabel}>Available to Everyone</span>}
        />
        <FormControlLabel
          value={'agency'}
          control={<Radio icon={<IconRadio width={16} height={16} />} checkedIcon={<IconRadioChecked width={16} height={16} />} className={styles.checkboxReview} />}
          label={<span className={styles.radioGroupLabel}>Restrict to Specific Agencies</span>}
        />
        <FormControlLabel
          value={'organization'}
          control={<Radio icon={<IconRadio width={16} height={16} />} checkedIcon={<IconRadioChecked width={16} height={16} />} className={styles.checkboxReview} />}
          label={<span className={styles.radioGroupLabel}>Restrict to Specific Organizations</span>}
        />
        <FormControlLabel
          value={'user'}
          control={<Radio icon={<IconRadio width={16} height={16} />} checkedIcon={<IconRadioChecked width={16} height={16} />} className={styles.checkboxReview} />}
          label={<span className={styles.radioGroupLabel}>Restrict to Specific Users</span>}
        />
      </RadioGroup>
      {radioButtonState === 'organization' && (
        <MultiSelectWithSearchDynamic
          error={errorOrganizaition}
          className={styles.dropdownContainer}
          onChange={getCompanies}
          label={'Feature Flags Available To'}
          returnAll={true}
          multiValue={selectedOrgs}
          dataSet={companies}
          isLoading={isLoadingCompanies}
          changeSelectedValue={selectedOrgChange}
          disabled={isLoadingFeatures}
          id="features-available-to"
        />
      )}
      {radioButtonState === 'user' && (
        <MultiSelectWithSearchDynamic
          error={errorUser}
          className={styles.dropdownContainer}
          onChange={getUsers}
          label={'Users Available To'}
          returnAll={true}
          multiValue={selectedUsers}
          dataSet={users || []}
          isLoading={isLoadingUsers}
          changeSelectedValue={selectedUsersChange}
          disabled={isLoadingFeatures}
          id="features-available-to-user"
          type="user"
        />
      )}
      {radioButtonState === 'agency' && (
        <MultiSelectWithSearchDynamic
          error={errorAgency}
          className={styles.dropdownContainer}
          onChange={getAgencies}
          label={'Agencies Available To'}
          returnAll={true}
          multiValue={selectedAgencies}
          dataSet={agencies || []}
          isLoading={isLoadingAgencies}
          changeSelectedValue={selectedAgenciesChange}
          disabled={isLoadingFeatures}
          id="features-available-to-agency"
        />
      )}
      {errorOrganizaition && <FormHelperText error>{errorOrganizaition}</FormHelperText>}
      {errorAgency && <FormHelperText error>{errorAgency}</FormHelperText>}
      {errorUser && <FormHelperText error>{errorUser}</FormHelperText>}
    </div>
  </>
);

export default ScopeSection;
